import { TextField } from "@justhome/react-ui";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import useFormStep from "../../lib/useFormStep";
import FormStep from "../FormStep";

const PostalCodeStep: FC = () => {
  const { t } = useTranslation();
  const { form, handleSubmit, handleBack } = useFormStep({
    next: "purchasePrice",
  });

  const {
    register,
    formState: { errors },
  } = form;

  return (
    <FormStep
      onBack={handleBack}
      onSubmit={handleSubmit}
      title={t("postalCode.title")}
      description={<>{t("postalCode.description")}</>}
    >
      <TextField
        {...register("postalCode", {
          required: t("postalCode.required"),
          pattern: {
            value: /^\d{4,5}$/,
            message: t("postalCode.invalid"),
          },
        })}
        autoComplete="off"
        maxLength={5}
        errorMessage={errors.postalCode?.message}
        autoFocus
        data-1p-ignore
        label={t("postalCode.label")}
        placeholder={t("postalCode.placeholder")}
        data-testid="postalCode"
      />
    </FormStep>
  );
};

export default PostalCodeStep;
